import React from "react";
import { Form } from "react-bootstrap";

export const CustomInput = (props) => {
  let { placeholder, name, value, onChange = () => null } = props;

  return (
    <div>
    <Form.Group>
      <Form.Control
        placeholder={placeholder}
        name={name}
        value={value ? value : ""}
        onChange={onChange}
      />
    </Form.Group>
    </div>
  );
};


export default CustomInput;
